import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import * as moment from 'moment';

import { environment } from '@environments/environment';

import { AgendamentoService } from '@app/shared/services';
import { CensoService } from '@app/shared/services/censo.service';
import { GerenciarAgendamentoService } from '@app/shared/services/gerenciar-agendamento.service';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { UtilService } from './../../shared/services/util.service';

import { Censo, Loading } from '@app/shared/models';

@Component({
  selector: 'app-agendamento',
  templateUrl: './agendamento.component.html',
  styleUrls: ['./agendamento.component.scss']
})
export class AgendamentoComponent implements OnInit {

  carregar = new Loading();
  censo: Censo;
  cliente = environment.cliente;
  dataEscolhida = new Date();
  dataInicial: Date;
  formAgendamento: FormGroup = new FormGroup({});
  formLogin: FormGroup = new FormGroup({});
  horarioSelecionado: any;
  horarios: any;
  locais: any;
  maxDate: Date;
  minDate: Date;
  usuario: any;
  dataAtual = moment(new Date(), 'YYYY-MM-DD');

  constructor(
    private agendamentoService: AgendamentoService,
    private censoService: CensoService,
    private formBuilder: FormBuilder,
    private gerenciarAgendamentoService: GerenciarAgendamentoService,
    private mensagemService: MensagemService,
    private utilService: UtilService
  ) {
    moment.locale('pt-BR');

    this.formLogin = this.formBuilder.group({
      cpf: [null, [Validators.required, (control: AbstractControl) => this.utilService.validatorsCustomCPF(control)]],
      dataNascimento: [null, [Validators.required, (control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      idCenso: this.cliente.censo_id,
      captcha: [null, Validators.required]
    });

    this.censoService.buscarCenso(this.cliente.censo_id).subscribe(data => this.censo = data);
  }

  ngOnInit(): void {
    this.gerenciarAgendamentoService.atualizarStatus('LOGIN');
  }

  submitFormLogin(): void {
    this.formLogin = this.utilService.verificarForm(this.formLogin);

    if (this.formLogin.invalid) {
      return this.mensagemService.avisoFormularioInvalido();
    }

    const dataNascimento = this.utilService.formatarDataPadraoHTML(this.formLogin.get('dataNascimento')?.value);

    if (this.censo.flagHabilitarBloqueio) {
      if (this.validarAcessoPorMesAniversario(dataNascimento)) {
        return this.mensagemService.avisoMensagemAlerta('Acesso bloqueado! Por favor, tente novamente no mês do seu aniversário.');
      }

      if (this.bloquearAcessoPorDataDeNascimento(dataNascimento)) {
        return this.mensagemService.avisoMensagemAlerta(this.censo.msgAcessoBloqueado);
      }
    }

    this.agendamentoService.autenticarUsuario(
      this.formLogin.get('cpf')?.value,
      this.utilService.formatarDataPadraoHTML(this.formLogin.get('dataNascimento')?.value),
      this.formLogin.get('idCenso')?.value,
      this.carregar
    ).subscribe(usuario => {
      this.usuario = usuario;
      this.buscarAgendamentosUsuario(usuario.cpf);
    });
  }

  private buscarAgendamentosUsuario(cpf: string): void {
    this.agendamentoService.buscarAgendamentos(this.censo.id, cpf, this.carregar).subscribe(agendamentos => {
      const TOTAL = agendamentos.filter((response: any) => response.status === 'AGENDADO').length;
      this.gerenciarAgendamentoService.atualizarStatus((TOTAL > 0) ? 'AGENDAMENTOS' : 'AGENDAR');
    });
  }

  resolved(captchaResponse: string): void {
    this.captcha = captchaResponse;
  }

  onError(errorDetails: any): void {
    this.captcha = null;
  }

  private validarAcessoPorMesAniversario(data: any): boolean {
    const dataNascimento = moment(data).year(this.dataAtual.year());
    return dataNascimento.isAfter(this.dataAtual, 'month');
  }

  private bloquearAcessoPorDataDeNascimento(dataNascimento: any): boolean {
    const DIA_BLOQUEIO = this.censo.diaBloqueio;
    const MES_BLOQUEIO = this.censo.mesBloqueio;

    const dataNascimentoMoment = moment(dataNascimento, 'YYYY-MM-DD');
    const dataBloqueio = moment().year(this.dataAtual.year()).month(dataNascimentoMoment.month()).add(MES_BLOQUEIO, 'month').date(DIA_BLOQUEIO);

    return this.dataAtual.isSameOrAfter(dataBloqueio);
  }

  get status(): String {
    return this.gerenciarAgendamentoService.status;
  }

  get captcha(): string {
    return this.formLogin.value.captcha;
  }

  set captcha(value) {
    this.formLogin.get('captcha').setValue(value);
  }

}
